import { Injectable } from '@angular/core';
import { CrudService } from '../../services';
import { Customer } from '../../dto/customer';
import {HttpParams, HttpClient, HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';
import {DateTableFilter} from '../../table-datasouces/date-table-filter';
import {PrevNextModel} from '../../models/prev-next-model';
import {toISODateString} from '../../providers/app-date-adapter';
import {SendUploadLinkModel} from '../../models/send-upload-link-model';
import {DeviceLoggedIn, IdvUploadDto, SofDecisionDto} from "../../dto/idv-upload";
import {UploadLink} from '../../dto/upload-link';
import {ChangeEmailModel} from '../../models/change-email-model';
import {ChangePhoneModel} from '../../models/change-phone-model';
import {CustomerIdModel} from '../../models/customer-id-model';
import {AddressUploadDto} from '../../dto/address-upload';
import {CustomerEmailLogDto} from '../../dto/customer-email-log-dto';
import {PushResult, SendPushDataModel, SendPushModel, SmsModel} from "../../models/sms-model";
import {BankTransferLoad} from '../../dto/bankTransferLoad';
import {SendUploadLinkResult} from '../../dto/send-upload-link-result';
import {WebIdTransaction} from '../../dto/web-id-transaction';
import {AddressStatus, IdentLevel, IdentStatus} from '../../dto/ident-status';
import {
  BankTransferLoadTransaction,
  CardToCardTransfer, DeclineReason,
  WhiteListedBankAccount
} from "../../dto/trustPayTransaction";
import {CustomerIdentDocumentModel} from '../../models/customer-ident-document-model';
import {CustomerOverviewViewContainerDto} from '../../dto/customerOverviewViewContainerDto';
import {CustomerView} from '../../dto/customerView';
import {ResendWebidModel} from '../../models/resend-webid-model';

import {IdentTransactionFile} from '../../dto/ident-transaction-file';
import {SmsDeliveryLog} from '../../dto/smsDeliveryLog';
import {CustomerCashback} from "../../models/customer-cashback";
import {FcmSent} from "../../dto/fcm-sent";
import {PepStatus} from "../../dto/pep-status";
import {CustomerIban} from "../../dto/product";


@Injectable({
  providedIn: 'root'
})
export class CustomersService implements CrudService<Customer> {
  readonly apiPath = 'customers/';
  readonly apiPathOverview = 'customer-overview/';

  constructor(protected http: HttpClient) { }
  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<Customer>;
  }

  getOverview(id: number): Observable<CustomerOverviewViewContainerDto> {
    return this.http.get(this.apiPathOverview + 'get/' + id) as Observable<CustomerOverviewViewContainerDto>;
  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string },
    companiesFilter?: string[],
    additionalField1?: string,
    additionalField2?: string,
    additionalValue1?: string,
    additionalValue2?: string,
    identStatusFilter?: string[],
    productsFilter?: string[],
    cardStatusFilter?: string[],
    countriesFilter?: string[],
  ) {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('someAdditionalData', someAdditionalData);

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }
    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }
    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (countriesFilter instanceof Array) {
      countriesFilter.forEach(element => {
        params = params.append('countriesFilter', element);
      });
    }

    if (identStatusFilter instanceof Array) {
      identStatusFilter.forEach(element => {
        params = params.append('identStatusFilter', element);
      });
    }


    return this.http.get(this.apiPath, { params }) as Observable<DataListModel<Customer>>;
  }

  createInternalUploadLink(model: SendUploadLinkModel) {
    return this.http.post(this.apiPath + 'create-internal-upload-link', model) as Observable<SendUploadLinkResult>;
  }

  sendUploadLink(model: SendUploadLinkModel) {
    return this.http.post(this.apiPath + 'send-upload-link', model);
  }

  changeEmail(model: ChangeEmailModel) {
    return this.http.post(this.apiPath + 'change-email-with-verification', model);
  }


  confirmChangePhone(model: ChangePhoneModel) {
    return this.http.patch(this.apiPath + 'confirm-phone-with-verification', model);
  }

  changePhone(model: ChangePhoneModel) {
    return this.http.post(this.apiPath + 'change-phone-with-verification', model);
  }

  deleteChangePhone(customerId: number) {
    const customerModel = new CustomerIdModel();
    customerModel.id = customerId;

    return this.http.put(this.apiPath + 'delete-phone-with-verification', customerModel);
  }

  resendDocPaymentLink(invoiceId: number) {
    return this.http.post(this.apiPath + 'resend-doc-payment-link', invoiceId);
  }

  resendDocInvoice(invoiceId: number) {
    return this.http.post(this.apiPath + 'resend-doc-invoice', invoiceId);
  }

  resendDocUploadLink(invoiceId: number) {
    return this.http.post(this.apiPath + 'resend-doc-upload-link', invoiceId);
  }

  sendDocPaymentLink(model: SendUploadLinkModel) {
    return this.http.post(this.apiPath + 'send-doc-payment-link', model);
  }

  add(item: Customer): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  sendSMS(item: SmsModel) {
    return this.http.post(this.apiPath + 'send-sms', item);
  }

  sendPush(item: SendPushModel): Observable<PushResult> {
    return this.http.post(this.apiPath + 'send-push', item) as Observable<PushResult>;
  }

  sendPushData(item: SendPushDataModel): Observable<PushResult> {
    return this.http.post(this.apiPath + 'send-push-data', item) as Observable<PushResult>;
  }

  syncAddressToGps(customerId: number) {
    return this.http.post(this.apiPath + 'sync-address-to-gps/' + customerId, {hello:'world'});
  }

  syncPersonalDataToGps(customerId: number) {
    return this.http.post(this.apiPath + 'sync-personal-data-to-gps/' + customerId, {hi:'mum'});
  }

  update( item: Customer ) {
    item.cards = [];
    return this.http.put(this.apiPath, item) as Observable<Customer>;
  }

  delete(id: any) {
    return this.deleteMany([id]);
  }
  restore(id: any) {
    return this.restoreMany([id]);
  }

  deleteMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }
  restoreMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath, null, { params: httpParams });
  }


  getFilterParams(filters: DateTableFilter): HttpParams {
    const str = filters?.str || '';
    const dateFilterCols = filters?.dateFilterCols || [];
    const startFilterDate = filters?.startFilterDate || null;
    const endFilterDate = filters?.endFilterDate || null;
    const companiesFilter = filters?.companiesFilter || null;

    let params = new HttpParams()


      .set('filterString', str)
      .set('someAdditionalData', filters?.someAdditionalData)
      .set('startFilterDate', toISODateString(startFilterDate))
      .set('endFilterDate', toISODateString(endFilterDate));
    if (filters?.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters?.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }

    if (filters?.enumFilter) {
      params = params.set('enumFilter', filters.enumFilter.value + '_' + filters.enumFilter.key);
    }

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return params;
  }



  getPrev(filters: DateTableFilter, customerId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${customerId}/prev`, { params }) as Observable<number>;
  }

  getNext(filters: DateTableFilter, customerId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${customerId}/next`, { params }) as Observable<number>;
  }

  getPrevNext(filters: DateTableFilter, customerId: number): Observable<PrevNextModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${customerId}/prev-next`, { params }) as Observable<PrevNextModel>;
  }

  getIdv(customerId: number): Observable<any> {
    return this.http.get(this.apiPath + 'get-idv/' + customerId) as Observable<IdvUploadDto[]>;
  }
  getIbans(customerId: number): Observable<any> {
    const params = new HttpParams()
      .set('id', customerId.toString())

    return this.http.get(this.apiPath + 'ibans', {params}) as Observable<CustomerIban[]>;
  }

  getLastFcmSents(customerId: number, skip: number, take: number): Observable<FcmSent[]> {
    const params = new HttpParams()
      .set('customerId', customerId.toString())
      .set('skip', skip.toString())
      .set('take', take.toString());

    return this.http.get<FcmSent[]>(this.apiPath + 'last-fcm-sents', { params });
  }

  getDevicesLoggedIn(customerId: number): Observable<DeviceLoggedIn[]> {
    return this.http.get(this.apiPath + 'devices-logged-in/' + customerId) as Observable<DeviceLoggedIn[]>;
  }


  // gets BTL since 1 year
  getBankTransferLoads(customerId: number): Observable<BankTransferLoad[]> {
    return this.http.get(this.apiPath + 'get-btl/' + customerId) as Observable<BankTransferLoad[]>;
  }

  getSmsDeliveries(customerId: number): Observable<SmsDeliveryLog[]> {
    return this.http.get(this.apiPath + 'sms-deliveries/' + customerId) as Observable<SmsDeliveryLog[]>;
  }

  getIdents(customerId: number): Observable<WebIdTransaction[]> {
    return this.http.get(this.apiPath + 'get-ident/' + customerId) as Observable<WebIdTransaction[]>;
  }

  getIdentFiles(identId: number): Observable<IdentTransactionFile[]> {
    return this.http.get(this.apiPath + 'get-ident-files/' + identId) as Observable<IdentTransactionFile[]>;
  }

  getCustomerEmailLogs(customerId: number): Observable<CustomerEmailLogDto[]> {
    return this.http.get(this.apiPath + 'get-email-logs/' + customerId + '/0/1000') as Observable<CustomerEmailLogDto[]>;
  }

  getIsAnyDocUploadActive(customerId: number): Observable<any> {
    return this.http.get(this.apiPath + 'is-any-doc-upload-active/' + customerId) as Observable<UploadLink>;
  }

  getIsAnyDocUploadInvoicePaid(customerId: number): Observable<any> {
    return this.http.get(this.apiPath + 'is-any-doc-upload-invoice-paid/' + customerId) as Observable<UploadLink>;
  }

  getOnlySofSingle(customerId: number): Observable<any> {
    return this.http.get(this.apiPath + 'get-only-sof-single/' + customerId) as Observable<IdvUploadDto[]>;
  }

  getOnlySofGeneric(customerId: number): Observable<any> {
    return this.http.get(this.apiPath + 'get-only-sof-generic/' + customerId) as Observable<IdvUploadDto[]>;
  }

  getOnlyDocs(customerId: number): Observable<any> {
    return this.http.get(this.apiPath + 'get-only-docs/' + customerId) as Observable<IdvUploadDto[]>;
  }

  getOnlyIdv(customerId: number): Observable<any> {
    return this.http.get(this.apiPath + 'get-only-idv/' + customerId) as Observable<IdvUploadDto[]>;
  }

  getOnlyAddressFiles(customerId: number): Observable<any> {

    let params = new HttpParams()
      .set('id', customerId)

    return this.http.get(this.apiPath + 'get-only-address-files', {params}) as Observable<AddressUploadDto[]>;
  }

  getOnlyOpenBankTransferLoads(customerId: number): Observable<any> {
    let params = new HttpParams()
      .set('customerId', customerId)
    return this.http.get(this.apiPath + 'get-only-open-btls', {params}) as Observable<BankTransferLoad[]>;
  }

  getAllDocuments(customerId: number): Observable<any> {
    let params = new HttpParams()
      .set('id', customerId)

    return this.http.get(this.apiPath + 'get-all-documents', {params}) as Observable<IdvUploadDto[]>;
  }

  getFile( fileId: number ): Observable<HttpResponse<Blob>> {
    return this.http.get( this.apiPath + 'get-file/' + fileId + '/response-file', { params: null, responseType: 'blob', observe: 'response' } );
  }

  getFileInline( fileId: number ): Observable<HttpResponse<Blob>> {
    return this.http.get( this.apiPath + 'get-file/' + fileId + '/response-inline-file', { params: null, responseType: 'blob', observe: 'response' } );
  }


  approveBankTransferLoadDocs(btlId: number) {
    return this.http.post(this.apiPath + 'approve-btl-docs/' + btlId, {app: 'rove'});
  }

  saveSofDecision(decisionDto: SofDecisionDto): Observable<string> {
    return this.http.post(this.apiPath + 'save-sof-decision', decisionDto) as Observable<string>;
  }

  setIdentLevel(customer: CustomerView, identLevel: IdentLevel): Observable<any> {
    const identLevelDto = {
      identLevel,
      customerId: customer.id,
    };
    return this.http.post(this.apiPath + 'set-ident-level', identLevelDto) as Observable<any>;
  }

  setPepStatus(customer: CustomerView, pepStatus: PepStatus): Observable<any> {
    const pepStatusDto = {
      pepStatus,
      customerId: customer.id,
    };
    return this.http.post(this.apiPath + 'set-pep-status', pepStatusDto) as Observable<any>;
  }

  setAddressStatus(customer: CustomerView, addressStatus: AddressStatus): Observable<any> {
    const addressStatusDto = {
      addressStatus,
      customerId: customer.id,
    };
    return this.http.post(this.apiPath + 'set-address-status', addressStatusDto) as Observable<any>;
  }

  getInboundCardToCardTransfers(customerId: number): Observable<CardToCardTransfer[]> {
    let params = new HttpParams()
      .set('customerId', customerId)

    return this.http.get(this.apiPath + 'inbound-c2c', {params}) as Observable<CardToCardTransfer[]>;
  }

  updateIdentDocument(customerId: number, data: CustomerIdentDocumentModel): Observable<Customer> {
    return this.http.post(this.apiPath + 'update-ident-document', {
      customerId,
      ...data
    }) as Observable<Customer>;
  }


  requestIdent(dlgResult: ResendWebidModel): Observable<Customer> {
    return this.http.post(this.apiPath + 'send-ident-link', {
      customerId: dlgResult.id,
    }) as Observable<Customer>;
  }

  getIdentFileInline(uploadId: number): Observable<HttpResponse<Blob>>  {
    return this.http.get(this.apiPath + 'ident-file/' + uploadId, { params: null, responseType: 'blob', observe: 'response' });
  }

  getCashbacks(customerId: number): Observable<CustomerCashback[]> {
    return this.http.get(this.apiPath + 'cashbacks/' + customerId) as Observable<CustomerCashback[]>;
  }

  syncMicroPaymentSessions(customerId: number) : Observable<string> {
    return this.http.post(this.apiPath + 'sync-micropayment-sessions', {customerId}) as Observable<string>;
  }

  anonymizeCustomer(customerId: number) {
    return this.http.post(this.apiPath + 'anonymize-customer', {customerId});
  }

  restoreAnonymizeCustomer(customerId: number, privateKeyPem: string|null) {
    return this.http.post(this.apiPath + 'restore-anonymized-customer', {customerId, privateKeyPem});
  }

  logoutDevice(deviceToken: string) {
    return this.http.post(this.apiPath + 'logout-app-device', {deviceToken});
  }

  getOpenUploadLinks(customerId: number) {

    let params = new HttpParams()
      .set('id', customerId)

    return this.http.get(this.apiPath + 'open-uploadlinks', {params}) as Observable<UploadLink[]>;
  }

  getCustomerWhiteListedBankAccounts(customerId: number) {

    let params = new HttpParams()
      .set('customerId', customerId)


    return this.http.get(`${this.apiPath}whitelisted-bank-accounts`, {params}) as Observable<WhiteListedBankAccount[]>;
  }

  getGlobalAllowedBankAccounts() {
    return this.http.get(`${this.apiPath}global-whitelisted-bank-accounts`) as Observable<WhiteListedBankAccount[]>;
  }

  globallyWhiteListBankAccount(senderAccountName: string, senderAccountNumber: string) {
    return this.http.post(`${this.apiPath}global-whitelisted-bank-accounts`, {
      senderAccountName,
      senderAccountNumber
    }) as Observable<any>;
  }


  markVulnerable(customerId: number, reason: string, source: string) {
    return this.http.post(this.apiPath + 'mark-vulnerable', {
      customerId,
      reason,
      source,
    });
  }

  getSofDeclineReasons() {
    return this.http.get(this.apiPath + 'sof-decline-reasons') as Observable<DeclineReason[]>;
  }
  getPoaDeclineReasons() {
    return this.http.get(this.apiPath + 'poa-decline-reasons') as Observable<DeclineReason[]>;
  }

}
